import { useState } from 'react'

import { ApiError } from '../../api/client'
import { useMe, useSetDarstellung, useSettings } from '../../hooks/queries'
import { ausEinstellungen, ausKonto, type Listensatz } from '../../lib/listenfarben'
import { Listenwahl } from './Listenwahl'

/**
 * Die Farben der Reiseübersicht — **an diesem Konto** (#54).
 *
 * **Diese Karte steht bei jedem**, nicht nur bei der Verwaltung: sie regelt
 * nichts an einer Reise, sondern etwas an den Augen dessen, der davorsitzt —
 * dieselbe Begründung wie bei der Schriftgröße daneben.
 *
 * **Leer heißt „wie die Voreinstellung"**, und der Knopf an jeder Zeile sagt
 * genau das. Aus dem Issue: „Diese können mit einem Knopf auf die
 * Voreinstellung zurück."
 */
export function Listenfarben() {
  const me = useMe()
  const vorein = useSettings()
  const sichern = useSetDarstellung()
  const [gemeldet, setGemeldet] = useState(false)
  const [problem, setProblem] = useState<string | null>(null)

  return (
    <div className="card card--seite">
      <h2 className="card__titel">Farben der Reiseübersicht</h2>
      <Listenwahl
        lead="Gilt für dich und für alle deine Geräte — niemand sonst sieht es. Eigene Reisen tragen zusätzlich einen Streifen an der linken Kante."
        werte={ausKonto(me.data)}
        /* Solange hier nichts steht, gilt die Voreinstellung -- und genau die
           zeigt dann auch das Farbfeld. */
        ererbt={ausEinstellungen(vorein.data?.settings)}
        leerText="Voreinstellung"
        alleText="Alles auf Voreinstellung"
        laeuft={sichern.isPending}
        fehler={problem}
        gemeldet={gemeldet}
        onSpeichern={async (satz: Listensatz) => {
          setGemeldet(false)
          setProblem(null)
          try {
            await sichern.mutateAsync({
              list_own_color: satz.own,
              list_other_color: satz.other,
              list_bg_color: satz.bg,
            })
            setGemeldet(true)
          } catch (fehler) {
            setProblem(
              fehler instanceof ApiError && fehler.offline
                ? 'Dafür braucht es Netz. Versuch es später noch einmal.'
                : fehler instanceof Error
                  ? fehler.message
                  : 'Das hat nicht geklappt.',
            )
            throw fehler
          }
        }}
      />
    </div>
  )
}
